<template>
  <div class="section" >
    <div class="more_f"></div>
    <div class="mains">
      <div class="left">
        <div class="left_one" :class="{showTan: showImg === 0}" @click="hover(0)">
          <div class="left_up">
            <img src="../assets/baobiao.png" alt="">
            <p class="title">报表统计</p>
          </div>
          <p class="title_eg">REPORT STATISTICS</p>
          <p class="content_zh">实时分类统计数据：设备、门店、货道等数据记录<br/>礼品库存、订单记录一键查询，尽收眼底</p>
        </div>
        <div class="left_two" :class="{showTan: showImg === 1}" @click="hover(1)">
          <div class="left_up">
            <img src="../assets/shebei.png" alt="">
            <p class="title">设备管理</p>
          </div>
          <p class="title_eg">DEVICE MANAGEMENT</p>
          <p class="content_zh">高效管理设备，特色分组运营功能<br/>只需一键购币，无需逐台扫码付款</p>
        </div>
        <div class="left_three" :class="{showTan: showImg === 2}" @click="hover(2)">
          <div class="left_up">
            <img src="../assets/yunying.png" alt="">
            <p class="title">运营推广</p>
          </div>
          <p class="title_eg">OPERATION PROMOTION</p>
          <p class="content_zh">自定义装饰店铺，加深消费者印象<br/>以及红包发放活动，精彩活动不容错过</p>
        </div>
      </div>
      <div class="middle">
        <div class="image">
          <img src="../assets/phone_p.png" alt="" v-if="defaultImg">
          <img src="../assets/baobiaotongji.gif" alt="" v-if="showImg === 0">
          <img src="../assets/deviceguanli.gif" alt="" v-if="showImg === 1">
          <img src="../assets/yunying.gif" alt="" v-if="showImg === 2">
          <img src="../assets/shangpinguanli.gif" alt="" v-if="showImg === 3">
          <img src="../assets/userguanli.gif" alt="" v-if="showImg === 4">
        </div>
      </div>
      <div class="right">
        <div class="right_one" :class="{showTan: showImg === 3}" @click="hover(3)">
          <div class="right_up">
            <p class="title">商品管理</p>
            <img src="../assets/goods.png" alt="">
          </div>
          <p class="title_eg">COMMODITY MANAGEMENT</p>
          <p class="content_right">套餐设置，其中特色反扫扣款仅需设置指定金额<br/>让设备扫描用户付款码即可轻松付款</p>
        </div>
        <div class="right_two" :class="{showTan: showImg === 4}" @click="hover(4)">
          <div class="right_up">
            <p class="title">用户管理</p>
            <img src="../assets/usermanage.png" alt="">
          </div>
          <p class="title_eg">USERS MANAGEMENT</p>
          <p class="content_right">建立会员制度，提高会员忠诚度<br/>配置会员卡充值赠送规格，刺激消费</p>
        </div>
        <div class="right_three">
          <div class="right_up">
            <p class="title">增值收入</p>
            <img src="../assets/income.png" alt="">
          </div>
          <p class="title_eg">VALUE ADDED INCOME</p>
          <p class="content_right">公众号直接获客，并额外获得<br/>平台广告分成，为您带来更多收入</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name:"Three",
  data(){
    return{
      showImg: -1,
      defaultImg: true
    }
  },
  methods:{
    hover (index) {
      this.defaultImg = false
      this.showImg = index
    },
    leave () {
      this.defaultImg = !this.defaultImg
      this.showImg = -1
    }
  }
}
</script>

<style scoped>
.section{
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.more_f{
  width: 577px;
  height: 119px;
  background: url(../assets/more_p.png) no-repeat;
  background-size: 100% 100%;
  margin-top: 120px;
}
.mains {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 75px;
  margin-bottom: 143px;
}
.left {
  width: 309px;
  height: 722px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.right {
   width: 295px;
   height: 722px;
   display: flex;
   flex-direction: column;
   justify-content: space-around;
   align-items: flex-end;
}
.left .left_one {
  width: 309px;
	height: 112px;
  /* background: url(../assets/report.png) no-repeat;
  background-size: 100% 100%; */
  margin-left: 130px;
  cursor: pointer;
  position: relative;
  top: 0;
  left: 0;
}
.left_up {
  display: flex;
  align-items: center;
}
.left_up .title {
  font-size: 20px;
  color: #333;
  font-weight: bold;
  margin-left: 10px;
}
.title_eg {
  font-size: 16px;
  color: #cccccc;
  margin-top: 5px;
}
.content_zh {
  font-size: 14px;
  color: #666666;
  line-height: 22px;
  position: absolute;
  bottom: 0;
  left: 0;
}
.left .left_two {
  width: 211px;
	height: 108px;
  /* background: url(../assets/device.png) no-repeat;
  background-size: 100% 100%; */
  cursor: pointer;
  position: relative;
  top: 0;
  left: 0;
}
.left .left_three {
  width: 239px;
	height: 111px;
  /* background: url(../assets/opreat.png) no-repeat;
  background-size: 100% 100%; */
  margin-left: 130px;
  cursor: pointer;
  position: relative;
  top: 0;
  left: 0;
}
.left .left_one::after, .left .left_two::after, .left .left_three::after {
  content: '';
  width:0;
  height:0;
  border-left:10px solid transparent;
  border-right:10px solid transparent;
  border-bottom:10px solid #016bff;
  position: absolute;
  bottom: -15px;
  left: 0;
  display: none;
}
.left .left_one.showTan::after, .left .left_two.showTan::after, .left .left_three.showTan::after {
  display: block;
}
.middle {
  width: 722px;
	height: 722px;
  background: url(../assets/bg_p.png) no-repeat;
}
.middle .image {
  width: 350px;
  height: 712px;
  margin: 0 auto;
}
.middle .image>img {
  width: 100%;
}
.right_up {
  display: flex;
  align-items: center;
}
.right_up .title {
  font-size: 20px;
  color: #333;
  font-weight: bold;
}
.right_up>img {
  margin-left: 10px;
}
.content_right {
  font-size: 14px;
  color: #666666;
  line-height: 24px;
  text-align: right;
  position: absolute;
  bottom: 0;
  left: 0;
}
.right .right_one {
  width: 295px;
	height: 110px;
  /* background: url(../assets/shangpin.png) no-repeat;
  background-size: 100% 100%; */
  margin-right: 130px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  position: relative;
  top: 0;
  left: 0;
}
.right .right_two {
 width: 225px;
	height: 112px;
  /* background: url(../assets/user.png) no-repeat;
  background-size: 100% 100%; */
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  cursor: pointer;
  position: relative;
  top: 0;
  left: 0;
}
.right .right_three {
  width: 211px;
  height: 111px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  /* background: url(../assets/zengzhi.png) no-repeat;
  background-size: 100% 100%; */
  margin-right: 130px;
  position: relative;
  top: 0;
  left: 0;
}
.right .right_one::after, .right .right_two::after {
  content: '';
  width:0;
  height:0;
  border-left:10px solid transparent;
  border-right:10px solid transparent;
  border-bottom:10px solid #016bff;
  position: absolute;
  bottom: -15px;
  right: 0;
  display: none;
}
.right .right_one.showTan::after, .right .right_two.showTan::after {
  display: block;
}
@media screen and (max-width: 1326px){
  .mains{
      transform: scale(0.9);
  }
}
@media screen and (max-width: 1200px){
  .mains{
      transform: scale(0.8);
  }
}
@media screen and (max-width: 1070px){
  .mains{
      transform: scale(0.78);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Second.vue